import { render } from "./aiModule.vue?vue&type=template&id=6095aa8a&scoped=true"
import script from "./aiModule.vue?vue&type=script&lang=js"
export * from "./aiModule.vue?vue&type=script&lang=js"

import "./aiModule.vue?vue&type=style&index=0&id=6095aa8a&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6095aa8a"]])

export default __exports__